import React, { useEffect, useRef, useState } from 'react'
import MainLogo from './images/imageAssets/Main-Logo.png'
import HeroBG from './images/imageAssets/HeroBG.jpg'

const images = require.context('./images/featured', false);
const imageList = images.keys().map(image => images(image));

function Hero() {

  let [SlideIndex, setSlideIndex] = useState(0)

  const showSlides = (slides)=>{
    setSlideIndex(SlideIndex++)
    if(SlideIndex >= slides.length){
      setSlideIndex(SlideIndex = 0);
    }

    slides.forEach(slide =>{
      slide.classList.remove('slideIn');
    })
    slides[SlideIndex].classList.add('slideIn');

  }


  useEffect(()=>{
    const slides = document.querySelectorAll('.featured-image-slide');
    slides[0].classList.add('firstSlide');
    
    const intervalId = setInterval(()=>{
      showSlides(slides);

    }, 3000)


    return () => clearInterval(intervalId);
  })
  
  
  return (
    <section id='HeroSection'>
      <img aria-hidden='true' className='section-background-image HeroBG' src={HeroBG} alt="" />
      <div className="container HeroSection">
        <header className='CTA-wrapper'>
          <img className='Hero-logo-image' src={MainLogo} alt="center line cabinets logo and name" />
          <a href="#GallerySection" className="button button--CTA">gallery</a>
        </header>
        <div className="featured-wroks-wrapper">
          <div className="featured-title">
            <h2 className="hero-featured-title asset-underline featured-title">crafting art for over 18 years</h2>
          </div>
          <div className="featured-image-slider">
            <div className="featured-image-slider-inner">
              {imageList.map((image, index) => (
                <img key={index} src={image} alt="" className="featured-image-slide" />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Hero